export default {
  path: '/parties',
  name: 'parties',
  component: () => import('../components/party/Layout'),
  redirect: { name: 'PartyList' },
  children: [
    {
      name: 'PartyList',
      path: '',
      component: () => import('../views/party/List')
    },
    {
      name: 'PartyCreate',
      path: 'new',
      component: () => import('../views/party/Create')
    },
    {
      name: 'PartyUpdate',
      path: ':id/edit',
      component: () => import('../views/party/Update')
    },
    {
      name: 'PartyShow',
      path: ':id',
      component: () => import('../views/party/Show')
    }
  ]
};
